export const initialState = {
  collectionsList: [],
  activeCollections: null,
  collectionsRes: null,
  loadingCollections: false,
  has_next: true,
  next_page: 1,
  offset: 0,
  prev_page: 0
};